import {
  Box,
  Group,
  NumberInput,
  RingProgress,
  Stack,
  Text,
  Title,
} from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { COLORS } from '../../../utils/constants'
import classes from '../../css/PricingStep.module.css'

interface PricingStepProps {
  price: number | null
  setPrice: (value: number) => void
}

const PricingStep = (props: PricingStepProps) => {
  const { price, setPrice } = props
  const isMobile = useMediaQuery('(max-width: 768px)')

  const handlePriceChange = (value: number | string) => {
    if (typeof value === 'number') {
      setPrice(value)
    } else {
      setPrice(0)
    }
  }

  const chartSections = [
    {
      value: 50,
      color: '#BDBDBD',
      tooltip: 'Hidden Gemz Share: 50%',
    },
    {
      value: 50,
      color: COLORS.LightGreen,
      tooltip: 'Your Share: 50%',
    },
  ]

  return (
    <Stack w='100%' align='center' gap='xl'>
      <NumberInput
        w='100%'
        value={price ?? ''}
        clampBehavior='blur'
        decimalScale={2}
        allowLeadingZeros={false}
        prefix='$'
        min={0}
        max={10000}
        onChange={handlePriceChange}
        variant='unstyled'
        fw={1000}
        size='100px'
        hideControls
        placeholder='$100 - $200'
        classNames={{ input: classes.pricingInput }}
        visibleFrom='sm'
      />
      <NumberInput
        w='100%'
        value={price ?? ''}
        clampBehavior='blur'
        decimalScale={2}
        allowLeadingZeros={false}
        prefix='$'
        min={0}
        max={10000}
        onChange={handlePriceChange}
        variant='unstyled'
        fw={1000}
        hideControls
        size='40px'
        placeholder='$100 - $200'
        classNames={{ input: classes.pricingInput }}
        hiddenFrom='sm'
      />
      <Title>per month</Title>

      <Box w='100%' ta='center'>
        <Group
          justify='center'
          align='center'
          gap={isMobile ? 0 : 'md'}
          wrap='nowrap'
        >
          {/* Your Share - Left */}
          <Stack
            align={isMobile ? 'center' : 'flex-end'}
            gap='xs'
            style={{ flex: 1, minWidth: 120 }}
          >
            <Text size={isMobile ? 'xs' : 'lg'} fw={600} c={COLORS.LightGreen}>
              Your Estimated <br />
              Monthly Earnings <br />
              {price && price > 0
                ? `$${(price * 10 * 0.5).toFixed(2)}`
                : '$0.00'}
              *
            </Text>
          </Stack>

          {/* Pie Chart - Center */}
          <RingProgress
            size={isMobile ? 100 : 200}
            thickness={isMobile ? 10 : 16}
            sections={chartSections}
          />

          {/* Hidden Gemz Share - Right */}
          <Stack
            align={isMobile ? 'center' : 'flex-start'}
            gap='xs'
            style={{ flex: 1, minWidth: 120 }}
          >
            <Text size={isMobile ? 'xs' : 'lg'} fw={600}>
              Our Share <br />
              {price && price > 0
                ? `$${(price * 10 * 0.5).toFixed(2)}`
                : '$0.00'}
            </Text>
          </Stack>
        </Group>
        <Text size='xs' c='dimmed' mt='xs'></Text>
        <Stack gap={'sm'} mt='md'>
          <Text size='xs' c='dimmed' ta='center'>
            *Earnings estimate assumes 10 advertisers booked for the month
            <br />
          </Text>{' '}
          <Text size='xs' c='dimmed' ta='center'>
            **Stripe charges a 2.9% + $0.30 fee per transaction that will be
            split between you and Hidden Gemz.
          </Text>
        </Stack>
      </Box>
    </Stack>
  )
}

export default PricingStep
